<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Sumitted Detail</strong> <span class="float-right"> {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="6">
          <b-form-group>
            <label for="ph_title">Address</label>
            <div v-if="model && model.group" v-html="model.group.address"></div>
          </b-form-group>
            </b-col>
            <b-col md="6">
          <b-form-group>
            <label for="ph_title">Company Name</label>
            <div v-if="model && model.group" v-html="model.group.groupname"></div>
          </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_title">Status</label>
                <div v-html="model.is_done ? 'Done' : 'Wating'"></div>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_title">Content Type</label>
                <div v-html="content_type"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_title">FileName</label>
                <div v-html="model.filename"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="model.is_done && !model.is_webshell">
            <b-col md="12">
              <b-form-group>
                <label for="ph_title">Description(Reason)</label>
                <div v-html="model.description"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
            <b-form-group>
              <label for="ph_descript">Content</label>
              <b-button class="float-right" size="sm" variant="warning" @click="decrypt" :disabled="decrypted">
                Force Decode base64
              </b-button>
              <hr>
              <div v-html="content || model.content || 'None'" style="padding:15px;background:#f5f5f5;border:1px solid #ccc;border-radius:5px;"></div>
            </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-form>
            <!-- <a id="download" :href="model.content" :download="model.filename" :v-show="true" style="text-decoration:none;!important;">
              <b-button size="sm" variant="primary" style="margin:0 2px;">
                Download
              </b-button>
            </a> -->
            <b-button size="sm" variant="danger" style="margin:0 2px;" @click="approve_confrm = true;" :disabled="model.is_done">
              Webshell Regist
            </b-button>
            <b-button size="sm" variant="success" @click="reject_confirm = true" :disabled="model.is_done">
              False positive
            </b-button>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Webshell Regist"  class="modal-danger" v-model="approve_confrm" @ok="approve" ok-variant="danger">
      Would You Like to Regist?
    </b-modal>
    <b-modal title="False positive"  class="modal-danger" v-model="reject_confirm" @ok="reject" ok-variant="danger">
      <b-form-group>
        <label for="ph_description">Description(Reason)</label>
        <b-form-textarea :rows="3" v-model="model.description" id="ph_description"></b-form-textarea>
    </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import forge from 'node-forge'

export default {
  data : () => {
    return {
      reject_confirm: false,
      approve_confrm: false,
      model : { is_binary : false },
      decrypted : false,
      content : '',
      content_type : ''
    }
  },
  computed: {
    startRow() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    decrypt : function() {
      try {
        // 바이너리일 경우 강제 내용 보기
        let data = this.model.content.split(',')[1]
        let content = forge.util.decode64(data)
        try {
          this.content = forge.util.decodeUtf8(content) // 한글 처리
        } catch (error) { this.content = unescape(content) }

      } catch (e) { this.$toastr.e('decode failed', 'not support this format') }
      finally { this.decrypted = true }
    },
    approve: function() { //등록 부분
      this.lock = true;
      Api.Manager_Call('wsfinder.webshell','approve', this.model)
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('approved.'), this.list(); this.$emit('refresh')
          } else {
            console.log("approve", 'failed', rs.description, this.model.id)
            this.$toastr.e('approve', "failed")
          }
          this.$emit('refresh');
          this.lock = false;
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    reject: function() {
      this.lock = true;
      Api.Manager_Call('wsfinder.webshell','reject', this.model)
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('rejected.'), this.list();
          } else {
            console.log("rejected", 'failed', rs.description, this.model.id)
            this.$toastr.e('rejected', "failed")
          }
          this.$emit('refresh');
          this.lock = false;
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    remove: function() {
      Api.Manager_Call('wsfinder.report','delete', { id : this.model.id})
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.description, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh");
      }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    list: function() { this.lock = false; this.$router.push({ name: 'wsfinder_submitted'}); },
    get: function(id = this.$route.params.id) {
      console.log('report.detail.vue', 'load item', id);
      Api.Manager_Call('wsfinder.report', 'detail' ,{id:id}).then(data => { this.model = Object.assign({}, this.model, data.body); })
      .then(() => {
        let type = this.model.content.split(';')[0];
        if(type) { this.content_type = type.replace('data:', '') }
        if (this.model.is_binary){ console.log('is_binary'); }
        else {
          let content = forge.util.decode64(this.model.content.split(',')[1], 'base64');
          this.model.content = forge.util.decodeUtf8(content)
        }
      })
      .catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('report.detail.vue', 'created'); },
  destroyed: function() { console.log('report.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('report.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}
</script>
